import TailSpin from "react-loader-spinner";

export default function Spinner() {
  return (
    <div className="display-flex-center">
      <TailSpin type="TailSpin" color="#3aaa35" />{" "}
    </div>
  );
}
